import { Badge } from '@/components/ui/badge';
import type { StudioSeriesStatus } from '@/types/studio-series';

const STATUS_CONFIG: Record<
  StudioSeriesStatus,
  { label: string; variant: 'success' | 'warning' | 'outline' | 'default' }
> = {
  draft: { label: 'Draft', variant: 'outline' },
  pending_review: { label: 'Pending review', variant: 'warning' },
  published: { label: 'Published', variant: 'success' },
  rejected: { label: 'Rejected', variant: 'default' },
};

interface CourseStatusPillProps {
  status: StudioSeriesStatus;
}

export function CourseStatusPill({ status }: CourseStatusPillProps) {
  const config = STATUS_CONFIG[status];
  return (
    <Badge variant={config.variant} size="sm" className="border-0">
      {config.label}
    </Badge>
  );
}
